import React from 'react';
import clipboardImage from '../images/clipboardPic.jpg'


function Hints({ giveUp, gameState, addHint,  hints, allHintsGiven  }) {
    return (
        <div className = "hints">
            <img 
            src={clipboardImage} />
            {gameState.isGameOver ? (
                <ul>
                    <li className = "game--over--clipboard">Play again tomorrow</li> 
                </ul>
            ) : (
                <ul>
                    {hints.map((hint, index) => (
                        <li key={index}>✔️ {hint}</li> 
                    ))}
                </ul>
            )}

            <p>{gameState.points}</p>
            {!allHintsGiven && (
            <button
            className="hint--button"
            onClick={addHint}>  </button>
            )}

            {allHintsGiven && (
            <button
            className="skip--button"
            onClick={giveUp}> SKIP </button>
            )}
            
        </div>
    );
}

export default Hints;